export const customerEnvironment = {
  applications: [
    {alias: 'profile', name: 'Profile', path: 'profile', route: ['profile']},
    {alias: 'setting', name: 'Setting', path: 'setting', route: ['setting']},

    {alias: 'capacity', name: 'Capacity', path: '/_apps/capacity', route: ['app', 'capacity'], default: true, menu : 'tools', icon : 'fa fa-fw fa-code-fork'},
    {alias: 'skill', name: 'Skill', path: '/_apps/skill', route: ['app', 'skill'], menu : 'tools', icon: 'fa fa-fw fa-graduation-cap'},
    {alias: 'impact', name: 'Impact', path: '/_apps/impact', route: ['app', 'impact'], menu : 'tools', icon: 'fa fa-fw fa-bullseye'},
    {alias: 'veri', name: 'Veri', path: '/_apps/veri', route: ['app', 'veri'], menu : 'tools', icon: 'fa fa-fw fa-certificate'},
    {alias: 'people', name: 'People', path: '/_apps/people', route: ['app', 'people'], menu : 'tools', icon: 'fa fa-fw fa-users'},

    {alias: 'scans', name: 'Scans', path: '/_apps/scans', route: ['app', 'scans'], menu : 'hero'},
    {alias: 'knows', name: 'Knows', path: '/_apps/knows', route: ['app', 'knows'], menu : 'hero'},
  ],

  menu : [
    {alias: 'tools', name: 'Tools', group : ['flow', 'veri', 'skills', 'people']},
    {alias: 'hero', name: 'Hero', group : ['scans', 'knows']},
  ],

  default_language: 'de',
  default_location: 'DE',

  session : {
    expired_soon: 300,
    auto_logout: true,
  },

  apis : {
    host: {
      host: 'https://boox.home.software.boox',
      apiKey: 'c9e2da2d935edb0a8611315feae5952190e5a72b9642f519982bf7816c220f07',
      rootPath: 'api/v2',
      envPath: 'system/environment',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
    },
    flow: {
      host: 'https://boox.home.software.boox',
      apiKey: 'f57c3c9a1a09b9739e27b7c4306aa05dea1428650b9ac33a1fce92e6fff44599',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    card: {
      host: 'https://boox.home.software.boox',
      apiKey: 'fb818a7cf8ac59aab77edd3318e01871e73ae3344aa848cf2ae65a3bf11a6171',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    veri: {
      host: 'https://boox.home.software.boox',
      apiKey: '7451ed35da80afa304583d795f9730faeed8359fbfd14e55031259f50e122120',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    profile: {
      host: 'https://boox.home.software.boox',
      apiKey: 'a12d64d81c8ea5187865faecb2599c757a0069321fdfda73899336b5058849b3',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    people: {
      host: 'https://boox.home.software.boox',
      apiKey: 'a12d64d81c8ea5187865faecb2599c757a0069321fdfda73899336b5058849b3',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
    develop: {
      host: 'https://boox.home.software.boox',
      apiKey: '9bf9f488f14a7b159e493adb4ad51df3e509ca8a3dcfc387170ea43a302e765b',
      rootPath: 'api/v2',
      headerApiKey: 'X-BooX-API-Key',
      headerSessionToken: 'X-BooX-Session-Token',
      envPath: 'system/environment',
    },
  },

  flow : { service : 'kapa' },
  people: { service: 'kapa' },

};
